import { motion } from 'framer-motion'

import { SimApnModal } from '@apps-common/apps/portal/pages/management/components/sim-apn'
import { ButtonRoundedWithIcon } from '@apps-common/components/elements'
import { VertSpacerLg, VertSpacerMd } from '@apps-common/components/layout'
import { ModalButton } from '@apps-common/components/modals'
import { commonIcons } from '@apps-common/config/icons'
import { GRID_CARD_VARIANTS } from '@apps-common/config/motion-variants'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import { ISimApnModel } from '@apps-common/types/management/sim-apn'

interface IProps {
  apn: ISimApnModel
}
export const SimApnListCard = ({ apn }: IProps) => {
  const { simApnId, simApnName, defaultItem } = apn

  return (
    <motion.div variants={GRID_CARD_VARIANTS} className='w-full p-6 rounded-[35px] bg-surface text-text border border-border'>
      <div className='flex items-center justify-between w-full'>
        <div className='jost-light text-[0.9em]'>{simApnName}</div>
      </div>
      <div className='flex flex-col gap-[5px] text-[0.9em]'>
        <VertSpacerMd />
        <div className='whitespace-nowrap flex items-center justify-start gap-[10px] capitalize text-[0.9em]'>
          <p className='jost-light text-ellipsis overflow-hidden bg-surface-2 leading-[1em] p-1 rounded'>Default item</p>
          <p className='jost-light text-ellipsis overflow-hidden'>{defaultItem ? 'Yes' : 'No'}</p>
        </div>
      </div>
      <VertSpacerLg />
      <ModalButton
        classes='w-full flex justify-end'
        component={SimApnModal}
        disabled={false}
        componentProps={{
          simApnId
        }}
        enterAnimation={modalSlideUpEnterAnimation}
        leaveAnimation={modalSlideUpLeaveAnimation}
      >
        <ButtonRoundedWithIcon
          type='div'
          text='Details'
          icon={<commonIcons.arrowAngled />}
          className='action-brand !w-auto !grow-0'
          iconContainerClassName='bg-brand text-on-brand'
        />
      </ModalButton>
    </motion.div>
  )
}
